<template>
	<div style="display: inline-block; position: relative;" :style="[{ margin: `${margin}` }]">
		<!-- :style="[{color: `${ color }`}]" -->
		<template v-if="btnType == 'btnImg'">
			<div class="btn" style="" :style="[
          { width: `${width}` },
          { height: `${height}` },
          { color: `${color}` },
          { fontSize: `${fontSize}` },
          { backgroundColor: `${backgroundColor}` },
          { fontSize: `${fontSize}` },
          { lineHeight: `${height}` },
        ]" @click="btnclick">
				<slot></slot>
				<img v-if="src" :src="src" :style="[ {width: `${ widthIcon }px`}, {height: `${ heightIcon }px`} ]"
					style="vertical-align: middle;" />
				{{ title }}
			</div>
			<div class="bodis" v-if="isOptional"></div>
		</template>
		<template v-if="btnType == 'btn'">
			<div style="text-align: center; user-select: none;line-height: 32px;border-radius: 2px; cursor: pointer;"
				:style="[{width: `${ width }`},{height: `${ height }`},{color: `${ color }`},{ fontSize: `${ fontSize }` },{backgroundColor: `${ backgroundColor }`},{fontSize: `${ fontSize }`},{lineHeight: `${ height }`} , { border: `${ border }` }]"
				@click="btnclick">
				<slot></slot>
				{{ title }}
			</div>
			<!-- optional -->
			<div class="bodis" v-if="isOptional">
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		props: {
			btnType: {
				type: String,
				default: "btnImg",
			},
			//文字颜色
			color: {
				type: String,
				default: "#000",
			},
			// 按钮宽度
			width: {
				type: String,
				default: "100%",
			},
			widthIcon: {
				type: Number,
				default: 16,
			},
			heightIcon: {
				type: Number,
				default: 16,
			},
			// 按钮高度
			height: {
				type: String,
				default: "32px",
			},
			// 按钮文本
			title: {
				type: String,
				default: "",
			},
			// 文字大小
			fontSize: {
				type: String,
				default: "12px",
			},
			// 按钮背景色
			backgroundColor: {
				type: String,
				default: "#E6E6E6",
			},
			// icon路径
			src: {
				type: String,
				default: "",
			},
			// 控制也用和禁用
			optional: {
				type: Boolean,
				default: false,
			},
			useAutoOptional: {
				type: Boolean,
				default: true,
			},
			// 禁用蒙版的宽度
			opwidth: {
				type: String,
				default: "70px",
			},
			// 禁用蒙版的定位
			top: {
				type: String,
				default: "222px",
			},
			margin: {
				type: String,
				default: "10px 8px",
			},
			border: {
				type: String,
				default: "",
			},
		},
		data() {
			return {
				tableRef: null,
				timer: null
			}
		},
		created() {},
		mounted() {
			if (this.useAutoOptional && ['查看', '修改', '编辑'].includes(this.title)) {
				this.findTable();
				// If not found immediately, retry a few times (in case table mounts later)
				let count = 0;
				this.timer = setInterval(() => {
					if (this.tableRef || count > 10) {
						clearInterval(this.timer);
						return;
					}
					this.findTable();
					count++;
				}, 200);
			}
		},
		beforeDestroy() {
			if (this.timer) clearInterval(this.timer);
		},
		computed: {
			isOptional() {
				if (!this.useAutoOptional) return this.optional;
				if (this.optional) return true;
				
				if (['查看', '修改', '编辑'].includes(this.title)) {
					if (this.title === '查看') {
						return false;
					}
					if (this.tableRef) {
						let refData = this.tableRef;
						// If the found table is a wrapper like ActivityRecordTable, try to read its selectData
						if (refData.$options && (refData.$options.name === 'ActivityRecordTable' || refData.$options.name === 'ActivityListTable')) {
							// For ActivityRecordTable, we might need to rely on its parent or itself if it maintains state
							if (refData.$children) {
								let childCommontable = refData.$children.find(child => 
									child.$options.name === 'Commontable' || 
									child.$options.name === 'common-table' || 
									child.$options.name === 'ElTable'
								);
								if (childCommontable) {
									refData = childCommontable;
								}
							}
						}

						// 判断该表格是否真的包含多选列（优先看已渲染列，避免仅靠 colnum 误判）
						let hasSelectionColumn = false;
						const tableRefs = refData.$refs || {};
						const tableRefKeys = ['multipleTable', 'fileTableSelect', 'fileTable', 'fileTable555', 'fileTable556', 'table57', 'table56'];
						for (const key of tableRefKeys) {
							const tableIns = tableRefs[key];
							if (tableIns && Array.isArray(tableIns.columns) && tableIns.columns.some(col => col && col.type === 'selection')) {
								hasSelectionColumn = true;
								break;
							}
						}
						if (!hasSelectionColumn && refData.headerData && Array.isArray(refData.headerData)) {
							hasSelectionColumn = refData.headerData.some(col => col.types === 'selection' || col.type === 'selection');
						}
						
						// 没有多选列时，“查看/修改/编辑”不要求勾选，单击行即可
						if (!hasSelectionColumn) {
							return false;
						}

						if (refData.selectData !== undefined) {
							return refData.selectData.length !== 1;
						} else if (refData.selection !== undefined) {
							return refData.selection.length !== 1;
						}
					}
					return true;
				}
				
				return false;
			}
		},
		methods: {
			findTable() {
				let parent = this.$parent;
				while (parent) {
					let table = this.searchDown(parent);
					if (table) {
						this.tableRef = table;
						return;
					}
					parent = parent.$parent;
				}
			},
			searchDown(rootNode) {
				if (!rootNode) return null;
				let queue = [rootNode];
				let elTables = [];
				while (queue.length > 0) {
					let node = queue.shift();
					if (!node || !node.$options) continue;
					
					// Skip dialogs entirely
					let name = node.$options.name || '';
					let tag = node.$options._componentTag || '';
					if (name.includes('Dialog') || tag.includes('Dialog') || name === 'ElDialog' || tag === 'ElDialog') {
						continue;
					}
					
					// Prefer Commontable
					if (name === 'Commontable' || name === 'common-table' || tag === 'Commontable' || tag === 'common-table' || name === 'ActivityRecordTable' || tag === 'ActivityRecordTable' || name === 'ActivityListTable' || tag === 'ActivityListTable') {
						return node;
					}
					// Collect native el-tables as fallback
					if (name === 'ElTable' || tag === 'el-table') {
						elTables.push(node);
					}
					
					if (node.$children) {
						for (let i = 0; i < node.$children.length; i++) {
							queue.push(node.$children[i]);
						}
					}
				}
				return elTables.length > 0 ? elTables[0] : null;
			},
			// 点击事件(子组件暴露父组件的事件)
			btnclick() {

				//console.log(this.optional,'optional');
				this.$emit("btnclick");
			},
		},
	};
</script>

<style lang="less">
	.bodis {
		width: 100%;
		height: 100%;
		opacity: 0.5;
		background-color: #ffffff;
		cursor: no-drop;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2000;
	}

	.btn {
		text-align: center;
		user-select: none;
		line-height: 32px;
		border-radius: 2px;
		border: 1px solid #e6e6e6;
		padding-left: 5px;
		padding-right: 5px;
		cursor: pointer;
	}

	.btn:hover {
		background-color: #f9f9f9 !important;
	}

	.btn:active {
		background-color: #f3f3f3 !important;
	}
</style>
